import {
    __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';


export const SlideButton = (props) => {
    const { defaultValue='normal',onChange,button={} } = props;

    return (<ToggleGroupControl
              className='vb-slide-button-hover'
                value={ defaultValue }
              isBlock
              __nextHasNoMarginBottom
              __next40pxDefaultSize
              onChange = {(value)=>onChange(value)}
            >
              { Object.entries(button).map(([key, value]) => (
              <ToggleGroupControlOption value={key} label={value} />
              ))}
          </ToggleGroupControl>
        )


}